import { listAgentConversationFeedback } from './agentConversationsApi';
import type { CommendaAiMessageFeedbackSummary } from './types';

/** Ratings this reader has already saved in a conversation, so the thumbs stay filled across a
 * reload. The unified list is run-scoped: a verdict on a run that produced no message has nothing
 * for the transcript to attach to, so it is dropped rather than keyed on an empty id. */
export async function listCommendaAiMessageFeedback(
  conversationId: string
): Promise<CommendaAiMessageFeedbackSummary[]> {
  const { feedback } = await listAgentConversationFeedback(conversationId);

  return feedback.flatMap((verdict) =>
    verdict.messageId === null
      ? []
      : [
          {
            messageId: verdict.messageId,
            rating: verdict.rating,
            category: verdict.category,
            comment: verdict.comment,
          },
        ]
  );
}
